module.exports = __webpack_public_path__ + "static/responsible-investments-mobile.622586b1.webp";